import { Route, Routes } from "react-router-dom";
import { Error404 } from "pages";
import JoinPage from "pages/join/Join";
import JoinLayout from "layout/JoinLayout";
// import JoinCheckPage from "pages/join/JoinCheck";

export default function JoinRoutes() {
    return (
        <Routes>
            <Route path="/*" element={ <JoinLayout/> }>
                {/* <Route path="joinCheck" element={ <JoinCheckPage /> }/> */}
                <Route path="join" element={ <JoinPage /> }/>
                <Route path="*" element={ <Error404/> }/>
            </Route>
        </Routes>
    );
}